import React, { useState } from 'react';
import styled, { keyframes, css } from 'styled-components';
import { useBreakpoints } from '@hooks/NewBreakpoint';
import { InitialsCircle } from './InitialsCircle';
import { MenuAndMail } from './MenuAndMail';
import { MenuDropDown } from './MenuDropDown';

const enter = keyframes`  
  from {opacity: 0; transform: translateY(-50%);}
  to {opacity: 1; transform: translateY(0);}
`;

const update = keyframes`
  from {opacity: 0;}
  to {opacity: 1;}
`;

const Layout = styled.div`
  position: absolute;
  top: 70px;
  height: 100%;
  right: 24px;
  z-index: 1;
  animation: ${({ toggle }) =>
    toggle
      ? css`
          ${update} 0.5s linear reverse forwards
        `
      : css`
          ${enter} 0.5s linear forwards
        `};
`;

const LayoutButton = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 0px 8px;
  height: 70px;
  background: ${(props) => props.open && '#EBEBEB'};
`;

const Chevron = styled.img`
  margin-left: 8px;
`;

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
`;

export const DropdownHeaderMenu = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [toggle, setToggle] = useState(false);

  const { breakpoint } = useBreakpoints();

  const toggleMenu = () => {
    if (isMenuOpen) {
      setIsMenuOpen(false);
      setToggle(false);
    } else {
      setIsMenuOpen(true);
      setToggle(true);
    }
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
    setToggle(false);
  };

  return (
    <>
      <LayoutButton id="header-dropdown" onClick={toggleMenu} open={isMenuOpen}>
        <InitialsCircle />
        {breakpoint !== 'xs' && <MenuAndMail />}
        <Chevron
          src="chevMenu.svg"
          alt="chevron"
          style={{ transform: isMenuOpen ? 'rotate(180deg)' : 'rotate(0deg)' }}
        />
      </LayoutButton>
      {isMenuOpen && (
        <>
          <Overlay onClick={closeMenu} />
          <Layout toggle={!toggle}>
            <MenuDropDown />
          </Layout>
        </>
      )}
    </>
  );
};

export default DropdownHeaderMenu;
